import { createEvent } from 'effector';

export const TN_SMS_DISCOUNT_CODE = 'TN15OFF';

export const setPromoShortCode = createEvent<string>();
export const setFromSms = createEvent<boolean>();
